'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _OrsUtil = require('./OrsUtil.js');

var _OrsUtil2 = _interopRequireDefault(_OrsUtil);

var _OrsInput = require('./OrsInput.js');

var _OrsInput2 = _interopRequireDefault(_OrsInput);

var _OrsGeocode = require('./OrsGeocode.js');

var _OrsGeocode2 = _interopRequireDefault(_OrsGeocode);

var _OrsIsochrones = require('./OrsIsochrones.js');

var _OrsIsochrones2 = _interopRequireDefault(_OrsIsochrones);

var _OrsMatrix = require('./OrsMatrix.js');

var _OrsMatrix2 = _interopRequireDefault(_OrsMatrix);

var _OrsDirections = require('./OrsDirections.js');

var _OrsDirections2 = _interopRequireDefault(_OrsDirections);

var _OrsPois = require('./OrsPois.js');

var _OrsPois2 = _interopRequireDefault(_OrsPois);

var _OrsElevation = require('./OrsElevation.js');

var _OrsElevation2 = _interopRequireDefault(_OrsElevation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Openrouteservice = {
  Util: _OrsUtil2.default,
  Input: _OrsInput2.default,
  Geocode: _OrsGeocode2.default,
  Isochrones: _OrsIsochrones2.default,
  Directions: _OrsDirections2.default,
  Matrix: _OrsMatrix2.default,
  Pois: _OrsPois2.default,
  Elevation: _OrsElevation2.default

  // define Openrouteservice for Node module pattern loaders, including Browserify
};if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
  module.exports = Openrouteservice;
  // define Openrouteservice as an AMD module
} else if (typeof define === 'function' && define.amd) {
  define(Openrouteservice);
}

if (typeof window !== 'undefined') {
  window.Openrouteservice = Openrouteservice;
}